import { AxiosError } from 'axios';
import { ChangeSummary } from 'web-library/models/UserGroupAccessConfiguration/UserGroupAccessConfiguration';
import { GET_PROFILE_AMENDMENT_REQUESTS_URL } from '../../constants/apiUrls';
import { GET_PROFILE_AMENDMENT_REQUESTS_QUERY_KEY } from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import { ProfileAmendmentRequestStatus } from './usePutCancelProfileAmendmentRequest';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request / Response
// =============================================================================
interface ProfileAmendmentRequestsChangeSummary extends ChangeSummary {
  itemType: string;
}

export interface ProfileAmendmentRequestsFile {
  fileName: string;
  fileSizeInBytes: string;
  fileUuid: string;
  isSubmitted: boolean;
}

export interface ProfileAmendmentRequestsResponse {
  approverRemarks: string | null;
  changeSummary: ProfileAmendmentRequestsChangeSummary[];
  files: ProfileAmendmentRequestsFile[];
  requestDateTime: string;
  requestorRemarks: string;
  status: ProfileAmendmentRequestStatus;
  uuid: string;
}

interface Input {
  onSuccess?: (res: ProfileAmendmentRequestsResponse[]) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

// =============================================================================
// Query
// =============================================================================

export const useGetProfileAmendmentRequests = ({ onError, onSuccess }: Input = {}) => {
  const getProfileAmendmentRequests = async () => {
    const res = await axiosClient.get<ProfileAmendmentRequestsResponse[]>(
      GET_PROFILE_AMENDMENT_REQUESTS_URL
    );
    return res.data;
  };

  return useCustomQuery(GET_PROFILE_AMENDMENT_REQUESTS_QUERY_KEY, getProfileAmendmentRequests, {
    onSuccess,
    onError,
  });
};
